<div *ngFor="let contact of contacts">
  <div class="notification-card">
    <div style="position: relative; height: 100%">
      <div style="display: inline-block">
        <p [style.color]="mainColor" class="notification-title">New request</p>
      </div>
      <div style="display: inline-block">
        <p [style.color]="mainColor" class="notification-date">&nbsp; - now...</p>
      </div>

      <mat-icon class="notification-icon">people</mat-icon>

      <p class="notification-text">
        Pending contact request for sharing from
        <span [style.color]="mainColor" class="notification-name"> {{ contact.from_user_info.full_name }}. </span>
      </p>

      <button *ngIf="showBtn" (click)="view(contact)" class="notification-btn" mat-raised-button>View</button>
    </div>
  </div>
</div>
